<script>
  import { createEventDispatcher } from 'svelte'
  import { cssPrefix } from '../helper-classes.js'
  import { portal } from '../utils.js'
  import { faXmark } from '@fortawesome/pro-regular-svg-icons'
  import Icon from '../Icon'

  export let active = false
  export let boxed = false
  export let id = null
  export let dark = false

  const dispatch = createEventDispatcher()

  export const open = () => {
    active = true
    document.documentElement.style.overflow = 'hidden'
  }
  export const close = () => {
    active = false
    document.documentElement.style.removeProperty('overflow')
    dispatch('close')
  }
</script>

<div use:portal={'body'} hidden class:theme-dark={dark} aria-modal="true">
  <div class={`${cssPrefix}modal`} class:is-active={active} {id} class:is-boxed={boxed}>
    <div class={`${cssPrefix}modal-overlay`} />
    <div class={`${cssPrefix}modal-frame`}>
      <div class={`${cssPrefix}modal-content`}>
        {#if boxed}
          <div class={`${cssPrefix}box`}>
            <slot />
            <button
              on:click={e => {
                e.preventDefault()
                close()
              }}
              class={`${cssPrefix}modal-close`}
            >
              <Icon icon={faXmark} />
            </button>
          </div>
        {:else}
          <slot />
        {/if}
      </div>
      {#if !boxed}
        <button
          on:click={e => {
            e.preventDefault()
            close()
          }}
          class={`${cssPrefix}modal-close`}
        >
          <Icon icon={faXmark} />
        </button>
      {/if}
    </div>
  </div>
</div>
